const isDiscount = (service) => service?.credit;

export default isDiscount;
